module.exports = __webpack_public_path__ + "sl.svg?dcc4cc62337033857156fc59f15fe5e2";